import React from 'react';
import OverviewBoard from '../../overview/OverviewBoard';

// The KPI Dashboard's Overview = THE Overview (owner, 1 Oct 2026): the same board and the same engine answer as the
// Home page's first tab (pages/overview/OverviewBoard, engine/api/overview.py), for the period and branch above - it
// reads no contracts or fleet list of its own any more.
export { UNPAID_FINES_SCOPE } from '../../overview/overview.logic';

const OverviewKPIs = ({ filters }) => (
    <OverviewBoard filters={{ from: filters.startDate, to: filters.endDate, branch: filters.branch || 'All' }} />
);

export default OverviewKPIs;
